import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import telegramService from "../../utils/telegram";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  /** X tugmasini yashirish (masalan majburiy tanlov modallari uchun) */
  hideClose?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, hideClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = "hidden";
    const offBack = telegramService.onBack(onClose);
    return () => {
      document.body.style.overflow = "";
      offBack();
    };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-5">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
            className="absolute inset-0 backdrop-blur-sm"
            style={{ backgroundColor: "var(--overlay)" }}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 8 }}
            transition={{ type: "spring", damping: 26, stiffness: 320 }}
            className="relative w-full max-w-sm bg-surface rounded-3xl shadow-elevated border border-line p-5 max-h-[80vh] overflow-y-auto"
          >
            {(title || !hideClose) && (
              <div className="flex items-center justify-between mb-4">
                {title && (
                  <h2 className="text-lg font-black text-content-primary tracking-tight">
                    {title}
                  </h2>
                )}
                {!hideClose && (
                  <button
                    onClick={() => {
                      telegramService.haptic("light");
                      onClose();
                    }}
                    aria-label="Close"
                    className="w-8 h-8 -mr-1 ml-auto rounded-xl flex items-center justify-center text-content-tertiary hover:bg-inset active:scale-95 transition-all"
                  >
                    <X size={18} />
                  </button>
                )}
              </div>
            )}
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
